import { CatalogObjectTypes } from './catalog-object';

/**
 * The Permission model is responsible of define the permissions of each user
 */
export interface Permission {
    id: number;
    /** Category to which each permission belongs e.g (projects, layers...) */
    type: CatalogObjectTypes;
    /** Type of permission e.g (READONLY, WRITE, FULL) */
    effect: PermAccessLevelString;
}

export enum PermAccessLevel {
    NONE = 'NONE',
    READONLY = 'READONLY',
    WRITE = 'WRITE',
    FULL = 'FULL',
}

export type PermAccessLevelString = keyof typeof PermAccessLevel;
